import React, { useState } from 'react';
import { Form, Input, Button, message, Alert } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { useNavigate, Link } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import api from '../api/client';

function ResendButton({ email }) {
  const [loading, setLoading] = useState(false);
  const [sent, setSent]       = useState(false);
  const resend = async () => {
    setLoading(true);
    try {
      await api.post('/api/auth/resend-verification', { email });
      setSent(true);
    } catch (e) {
      message.error(e.response?.data?.error || 'Could not resend verification email');
    } finally { setLoading(false); }
  };
  if (sent) return <span style={{ color: '#52c41a', fontSize: 12 }}>✓ Email sent</span>;
  return <Button type="link" size="small" loading={loading} onClick={resend} style={{ padding: 0, fontSize: 12 }}>Resend verification email</Button>;
}

export default function Login() {
  const [loading, setLoading]           = useState(false);
  const [unverifiedEmail, setUnverifiedEmail] = useState('');
  const { login } = useUser();
  const navigate  = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    setUnverifiedEmail('');
    try {
      const res = await api.post('/api/auth/login', values);
      login(res.data.accessToken);
      navigate('/dashboard');
    } catch (e) {
      const err = e.response?.data;
      if (err?.error === 'email_not_verified') {
        setUnverifiedEmail(err.email || values.email);
      } else {
        message.error(err?.error || 'Login failed');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fafafa' }}>
      <div style={{ width: 380 }}>
        <div style={{ marginBottom: 40, textAlign: 'center' }}>
          <div style={{ fontSize: 22, fontWeight: 700, letterSpacing: '-0.5px', color: '#0a0a0a' }}>SGLearner</div>
          <div style={{ fontSize: 13, color: '#888', marginTop: 6 }}>Singapore's PSLE, O-Level, JC & IB mastery platform</div>
        </div>

        <div style={{ background: '#fff', border: '1px solid #e8e8e8', borderRadius: 10, padding: '32px 32px' }}>
          <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 24, color: '#0a0a0a' }}>Sign in</h2>

          {unverifiedEmail && (
            <Alert
              type="warning"
              style={{ marginBottom: 20 }}
              message="Email not verified"
              description={
                <div>
                  <p style={{ margin: '4px 0 8px', fontSize: 13 }}>
                    Please verify your email address before logging in. Check <strong>{unverifiedEmail}</strong> for the link.
                  </p>
                  <ResendButton email={unverifiedEmail} />
                </div>
              }
              icon={<MailOutlined />}
              showIcon
            />
          )}

          <Form layout="vertical" onFinish={onFinish} requiredMark={false}>
            <Form.Item label="Email" name="email" rules={[{ required: true, type: 'email' }]}>
              <Input size="large" placeholder="you@email.com" />
            </Form.Item>
            <Form.Item label="Password" name="password" rules={[{ required: true }]}>
              <Input.Password size="large" placeholder="••••••••" />
            </Form.Item>
            <Form.Item style={{ marginBottom: 12 }}>
              <Button type="primary" htmlType="submit" block size="large" loading={loading}
                style={{ background: '#0a0a0a', border: 'none', fontWeight: 500 }}>
                Sign in
              </Button>
            </Form.Item>
          </Form>

          <div style={{ textAlign: 'center', fontSize: 13, color: '#666' }}>
            No account? <Link to="/register" style={{ color: '#0a0a0a', fontWeight: 500 }}>Create one</Link>
          </div>
          <div style={{ textAlign: 'center', fontSize: 13, color: '#666', marginTop: 8 }}>
            <Link to="/forgot-password" style={{ color: '#0a0a0a', fontWeight: 500 }}>Forgot password?</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
